enum MFAType {
  NONE = 'none',
  EMAIL = 'email',
  AUTHENTICATOR = 'authenticator',
  SMS = 'sms'
}

export default MFAType
